import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/style_legal_pages.css";
import {formatPhoneFR} from "../utils/validators";
import { useGlobalProperty } from "../context/GlobalPropertyContext";

export default function ConditionsUtilisation() {
  const navigate = useNavigate();
  const { globalProperties, loading: globalLoading } = useGlobalProperty();

  return (
    <div className="legal-page">
      <div className="legal-container">
        <button className="legal-back-btn" onClick={() => navigate(-1)}><ion-icon name="arrow-back-outline"></ion-icon>Retour</button>

        <header className="legal-header">
          <h1>Conditions d'Utilisation</h1>
          <p className="legal-subtitle">Lisez attentivement avant d'utiliser le site</p>
        </header>

        <article className="legal-content">
          
          <section className="legal-section">
            <h2>1. Acceptation des Conditions</h2>
            <p>
              En accédant et en utilisant le site latelierfloral.fr, vous acceptez intégralement ces conditions d'utilisation. Si vous n'acceptez pas ces conditions, veuillez ne pas utiliser le site.
            </p>
          </section>

          <section className="legal-section">
            <h2>2. Licence d'Utilisation</h2>
            <p>
              {globalProperties?.enterprise_info?.social_reason} vous octroie une licence non-exclusive, non-transférable et révocable pour utiliser le site à titre personnel et non-commercial.
            </p>
            <p>
              Cette licence vous permet de :
            </p>
            <ul>
              <li>Consulter le contenu du site</li>
              <li>Créer un compte utilisateur</li>
              <li>Effectuer des achats</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>3. Utilisation Interdite</h2>
            <p>
              Vous n'êtes pas autorisé à :
            </p>
            <ul>
              <li>Reproduire ou copier le contenu du site sans autorisation</li>
              <li>Utiliser le site à des fins commerciales non autorisées</li>
              <li>Accéder à des zones réservées ou contourner les mesures de sécurité</li>
              <li>Introduire des virus, codes malveillants ou tout élément nuisible</li>
              <li>Utiliser des robots, scrapers ou outils d'extraction de données</li>
              <li>Créer plusieurs comptes pour contourner les restrictions</li>
              <li>Harasser, menacer ou faire du spam</li>
              <li>Violer toute loi ou réglementation applicable</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>4. Création de Compte</h2>
            <p>
              Pour créer un compte, vous devez :
            </p>
            <ul>
              <li>Être âgé d'au moins 18 ans</li>
              <li>Fournir des informations exactes et à jour</li>
              <li>Maintenir la confidentialité de votre mot de passe</li>
              <li>Accepter la responsabilité de toutes les activités de votre compte</li>
            </ul>
            <p>
              {globalProperties?.enterprise_info?.social_reason} se réserve le droit de suspendre ou de supprimer les comptes qui violent ces conditions.
            </p>
          </section>

          <section className="legal-section">
            <h2>5. Produits et Tarifs</h2>
            <p>
              Les informations concernant les produits, tarifs et disponibilités sont fournies à titre informatif. {globalProperties?.enterprise_info?.social_reason} se réserve le droit de :
            </p>
            <ul>
              <li>Modifier les tarifs à tout moment</li>
              <li>Modifier les caractéristiques des produits</li>
              <li>Refuser ou annuler une commande</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>6. Processus de Commande</h2>
            <p>
              Lorsque vous passez une commande :
            </p>
            <ul>
              <li>Vous offrez d'acheter les produits sélectionnés</li>
              <li>{globalProperties?.enterprise_info?.social_reason} accepte ou rejette votre commande</li>
              <li>La confirmation de commande constitue un contrat de vente</li>
              <li>Vous acceptez de payer le prix total affiché</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>7. Paiement</h2>
            <p>
              Le paiement doit être effectué en totalité avant la livraison. Les méthodes de paiement acceptées sont affichées lors du processus de commande.
            </p>
            <p>
              Tous les paiements sont traités de manière sécurisée. {globalProperties?.enterprise_info?.social_reason} n'est pas responsable des erreurs ou fraudes de paiement.
            </p>
          </section>

          <section className="legal-section">
            <h2>8. Livraison</h2>
            <p>
              Les délais de livraison sont estimatifs. {globalProperties?.enterprise_info?.social_reason} s'engage à livrer les produits commandés dans les délais annoncés. Cependant, il ne peut être tenu responsable des retards de livraison causés par :
            </p>
            <ul>
              <li>Les conditions météorologiques</li>
              <li>Les défaillances du transporteur</li>
              <li>Les événements imprévisibles</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>9. Politique de Retour et Remboursement</h2>
            <p>
              Les produits périssables (fleurs fraiches) ne peuvent être retournés ou remboursés, sauf en cas de défaut de qualité ou de livraison non conforme.
            </p>
            <p>
              Pour les autres produits, vous disposez d'un délai de 14 jours pour demander un retour ou un remboursement.
            </p>
            <p>
              Les frais de retour sont à votre charge, sauf en cas de défaut du produit.
            </p>
          </section>

          <section className="legal-section">
            <h2>10. Responsabilité</h2>
            <p>
              {globalProperties?.enterprise_info?.social_reason} décline toute responsabilité pour :
            </p>
            <ul>
              <li>Les dommages causés par l'utilisation du site</li>
              <li>Les dysfonctionnements techniques</li>
              <li>Les interruptions de service</li>
              <li>La perte de données</li>
              <li>Les préjudices indirects</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>11. Contenu Utilisateur</h2>
            <p>
              Si vous soumettez du contenu (commentaires, avis, etc.) :
            </p>
            <ul>
              <li>Vous garantissez être propriétaire de ce contenu</li>
              <li>Vous accordez à {globalProperties?.enterprise_info?.social_reason} une licence pour utiliser ce contenu</li>
              <li>Vous garantissez que le contenu ne viole aucun droit tiers</li>
              <li>Vous êtes responsable de tout préjudice causé par votre contenu</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>12. Propriété Intellectuelle</h2>
            <p>
              Tout le contenu du site (textes, images, vidéos, logos, etc.) est la propriété exclusive de {globalProperties?.enterprise_info?.social_reason} et protégé par les droits d'auteur.
            </p>
            <p>
              Vous ne pouvez pas reproduire, adapter ou modifier ce contenu sans autorisation écrite préalable.
            </p>
          </section>

          <section className="legal-section">
            <h2>13. Liens Externes</h2>
            <p>
              Le site peut contenir des liens vers des sites externes. {globalProperties?.enterprise_info?.social_reason} n'est pas responsable du contenu de ces sites externes.
            </p>
            <p>
              L'utilisation de ces liens se fait à vos risques et périls.
            </p>
          </section>

          <section className="legal-section">
            <h2>14. Modification des Conditions</h2>
            <p>
              {globalProperties?.enterprise_info?.social_reason} se réserve le droit de modifier ces conditions d'utilisation à tout moment. Les modifications prendront effet immédiatement après leur publication.
            </p>
            <p>
              Votre utilisation continue du site après une modification constitue votre acceptation des nouvelles conditions.
            </p>
          </section>

          <section className="legal-section">
            <h2>15. Résiliation</h2>
            <p>
              {globalProperties?.enterprise_info?.social_reason} peut résilier ou suspendre votre accès au site à tout moment, sans préavis, si :
            </p>
            <ul>
              <li>Vous violez ces conditions d'utilisation</li>
              <li>Vous engagez des activités illégales</li>
              <li>Vous posez un risque de sécurité</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>16. Droit Applicable et Juridiction</h2>
            <p>
              Ces conditions d'utilisation sont régies par la loi française. Tout litige sera soumis à la juridiction compétente du tribunal de Montpellier.
            </p>
          </section>

          <section className="legal-section last">
            <h2>17. Contact</h2>
            <p>
              Pour toute question concernant ces conditions d'utilisation, veuillez nous contacter à :
            </p>
            <p>
              {globalProperties?.contacte?.email !== "" && <><strong>Email : </strong>{globalProperties?.contacte?.email || ""}<br /></>}
              {globalProperties?.contacte?.phone !== "" && <><strong>Téléphone : </strong>{formatPhoneFR(globalProperties?.contacte?.phone || "")}</>}
            </p>
            <p className="legal-date">
              <em>Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}</em>
            </p>
          </section>

        </article>
      </div>
    </div>
  );
}